import React, { useState, useEffect } from "react";
import Template from "./InputText.jsx";

const urlRegex = /^https?:\/\//i;

const InputController = (props) => {
  const [value, setValue] = useState(props.value);
  const [focus, setFocus] = useState(false);
  const isUrl = props.type === "url";

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const fixUrlValue = () => {
    if (!value) return;
    if (urlRegex.test(value)) return;

    setValue("http://" + value);
  };

  const onBlur = (e) => {
    setFocus(false);

    if (isUrl) {
      fixUrlValue();
    }

    if (props.onBlur) {
      props.onBlur(e);
    }
  };

  const onFocus = (e) => {
    setFocus(true);

    if (props.onFocus) {
      props.onFocus(e);
    }
  };

  const onChange = (e) => {
    const { value: textValue } = e.target;
    const { type, name, onChange } = props;

    let updatedValue = textValue;
    setValue(textValue);

    if (type === "number") {
      updatedValue = parseInt(textValue);
    }

    if (onChange) {
      onChange({ target: { name, value: updatedValue } });
    }
  };

  return (
    <Template
      ref={props.inputRef}
      {...props}
      value={value}
      focus={focus}
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={onChange}
    />
  );
};

export default InputController;
